<!--
 * @Author: shiao
 * @Date: 2020-12-28 15:31:14
 * @LastEditTime: 2021-01-08 17:05:22
 * @Description: 
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\components\networkerror.vue
-->
<template>
  <div class="networkerror-div">
    <div class="error-img"><img :src="networkerroricon" alt="" /></div>
    <div class="error-text">您的网络不太给力，请稍后再试</div>
    <div class="error-reload-btn" @click="networkreload">重新加载</div>
  </div>
</template>

<script>
export default {
  name: "networkerror",
  data() {
    return {
      networkerroricon: require("@/assets/hotel/img/micon/network-error-icon.png"),
    };
  },
  methods: {
    networkreload() {
      this.$emit("networkreload", true);
    },
  },
};
</script>

<style scoped lang='less'>
.networkerror-div {
  .error-img {
    width: 200px;
    height: 200px;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .error-text {
    text-align: center;
    height: 24px;
    font-size: 17px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    padding: 30px 0 20px 0;
  }
  .error-reload-btn {
    background: linear-gradient(135deg, #0fbf6d 0%, #108b30 100%);
    border-radius: 23px;
    width: 64px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 22px;
    padding: 9px 33px;
    margin: auto;
  }
}
</style>
